// extracted by mini-css-extract-plugin
module.exports = {"abtn_box":"Abutton_abtn_box__23hlo","btn_diamond":"Abutton_btn_diamond__3yKqk","btn_bagcolor":"Abutton_btn_bagcolor__3jvhG"};